/**
 * Customer API 호출 커스텀 Hook
 */

import { useState, useEffect } from 'react'
import { AxiosError } from 'axios'
import apiClient from '../api/apiClient'

export interface Customer {
  id: number
  customerName: string
}

export function useCustomers() {
  const [customers, setCustomers] = useState<Customer[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        setLoading(true)
        setError(null)

        const response = await apiClient.get<any[]>('/api/customers')
        // Map customers and ensure each has an id field
        // If id is missing, use a hash of customerName as fallback
        const customersWithIds = (response.data || []).map((customer: any) => ({
          id: customer.id || Math.abs(customer.customerName.split('').reduce((acc: number, char: string) => acc + char.charCodeAt(0), 0) % 1000000),
          customerName: customer.customerName
        }))
        setCustomers(customersWithIds)
      } catch (err) {
        const message = err instanceof AxiosError
          ? err.response?.data?.message || err.message
          : '알 수 없는 오류'
        setError(message)
        console.error('Failed to fetch customers:', err)
        setCustomers([])
      } finally {
        setLoading(false)
      }
    }

    fetchCustomers()
  }, [])

  return {
    customers,
    loading,
    error
  }
}
